<style lang="less" scoped>
  @import "../../../style/theme.less";

  #layout-container {
    height: 100%;
    width: 100%;
    position: absolute;
    transition: opacity .3s @ease-in-out;

    .trigger {
      font-size: 18px;
      line-height: 64px;
      padding: 0 24px;
      cursor: pointer;
      transition: color 0.3s;

      :hover {
        color: @primary-color;
      }
    }

    #layout {
      background: linear-gradient(to right, @layout-header-background 10%, @layout-body-background 11%);

      #layout-sider {
        overflow: auto;
        height: 100vh;
        left: 0;
      }

      #layout-header {
        color: @text-color-inverse;
        padding: 0;
        z-index: 1;

        #user-container {
          float: right;
          margin-right: 8px;

          .button {
            color: @text-color-inverse;
            padding: 0 12px;

            &:hover {
              color: @primary-color;
            }
          }
        }
      }

      #content-background {
        height: ~"calc(100% - 64px)";
        width: 300px;
        position: absolute;
        z-index: 0;
        background-color: @layout-body-background;
        margin-top: 64px;
        border-radius: @border-radius-base 0 0 0;
        transition: all .3s @ease-in-out;
      }

      #content-container {
        z-index: 1;
        margin: 24px 16px;
        padding: 24px;
        background: @component-background;
        border-radius: @border-radius-base;
        overflow: auto;
      }

    }

  }

</style>

<template>
  <a-layout id="layout-container" v-if="authenticated">

    <a-layout-sider id="layout-sider" v-model="siderCollapsed" :trigger="null" collapsible>
      <sider-content />
    </a-layout-sider>

    <a-layout id="layout">
      <a-layout-header id="layout-header">

        <a-row type="flex">
          <a-col flex="66px">
            <a-icon
              class="trigger"
              :type="siderCollapsed ? 'menu-unfold' : 'menu-fold'"
              @click="() => toggleSiderCollapsed()"
            />
          </a-col>
          <a-col flex="auto" />
          <a-col flex="auto">
            <a-row type="flex" id="user-container">
              <a-col flex="auto">
                <a-tooltip placement="bottom">
                  <template slot="title">
                    <span>Logout</span>
                  </template>
                  <a-button class="button" type="link" @click="logout">
                    <a-icon type="logout" />
                  </a-button>
                </a-tooltip>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-layout-header>

      <div id="content-background"/>

      <a-layout-content id="content-container">

        <a-spin :spinning="isLoading" size="large">
          <div class="spin-content">
            <a-alert v-if="error.show" :message="error.message" type="info" show-icon style="margin-bottom: 16px;" />
            <vue-page-transition name="fade-in-left">
              <router-view />
            </vue-page-transition>
          </div>
        </a-spin>

      </a-layout-content>
    </a-layout>

  </a-layout>
  <login-modal v-else />
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex';

import siderContent from './_sider-content';
import loginModal from './_login-modal';

export default {
  name: 'admin',

  components: {
    siderContent,
    loginModal,
  },

  computed: {
    ...mapState('admin', ['siderCollapsed', 'error',]),
    ...mapGetters('admin', ['authenticated', 'isLoading',]),
  },

  methods: mapActions('admin', ['toggleSiderCollapsed', 'logout', ]),

};
</script>

